import * as c from '../constants/SettingsConstants'

const initialState = {
  fetching: false,
  fetched: false,
  error: null,
  data: {},
  examWindowRefData: {},
  examDateRefData: [],
}

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case `${c.FETCH_EXAM_WINDOWS}_PENDING`:
      return { ...state, fetching: true, fetched: false, error: null }

    case `${c.FETCH_EXAM_WINDOWS}_FULFILLED`: {
      const { data, examWindowRefData, examDateRefData } = payload
      return {
        ...state,
        fetching: false,
        fetched: true,
        data: {
          ...state.data,
          ...data,
        },
        examWindowRefData: {
          ...state.examWindowRefData,
          ...examWindowRefData,
        },
        examDateRefData: [...state.examDateRefData, ...examDateRefData],
      }
    }

    case `${c.FETCH_EXAM_WINDOWS}_REJECTED`:
      return { ...state, fetching: false, fetched: false, error: payload }

    default:
      return state
  }
}
